export default {
    "NO": {
        "member": {
            "text": "Medlemskap",
            "target": "",
            "title": "og abonnement ",
            "url": "/no/medlemskap-og-abonnement-2/"
        },
        "press": {
            "text": "Pressemeldinger",
            "target": "Pressmeddelanden",
            "title": "Les mer",
            "url": "/no/pressemeldinger/"
        },
        "events": {
            "text": "Kommende event",
            "target": "",
            "title": "Les mer",
            "url": "/no/radars-eventer/"
        },
        "insights": {
            "text": "Ny innsikt",
            "target": "",
            "title": "Insikter",
            "url": "/no/datadrevet-innsikt/"
        }
    },
    "SE": {
        "member": {
            "text": "Partnerskap",
            "target": "",
            "title": "och insiktshub",
            "url": "/tjanster-radgivning/partnerskap-och-insiktshub/"
        },
        "press": {
            "text": "Nu kommer vi till er",
            "target": "",
            "title": "Läs mer",
            "url": "/2024/nu-kommer-radar-till-er/"
        },
        "events": {
            "text": "Kommande event",
            "target": "",
            "title": "Läs mer",
            "url": "/event/"
        },
        "insights": {
            "text": "Nya insikter",
            "target": "",
            "title": "Insikter",
            "url": "/insikter/"
        }
    },
    "EN": {
        "member": {
            "text": "Membership",
            "target": "",
            "title": "and company services",
            "url": "/en/services-advisory-membership-in-radars-network/"
        },
        "press": {
            "text": "Press releases",
            "target": "",
            "title": "Read more",
            "url": "/en/about-us/press-releases/"
        },
        "events": {
            "text": "Upcoming events",
            "target": "",
            "title": "Read more",
            "url": "/en/events/"
        },
        "insights": {
            "text": "New insights",
            "target": "",
            "title": "Insights",
            "url": "/en/insights/"
        }
    }
}